(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var toast = document.querySelector('[data-cart-toast]');
    var toastText = document.querySelector('[data-cart-toast-text]');
    var cartCount = document.querySelector('[data-cart-count]');
    var hideTimer = null;

    function showToast(message) {
      if (!toast) return;
      if (message && toastText) toastText.textContent = message;
      toast.removeAttribute('hidden');
      // Force a reflow so the transition runs
      void toast.offsetWidth;
      toast.classList.add('is-visible');
      clearTimeout(hideTimer);
      hideTimer = setTimeout(hideToast, 3500);
    }

    function hideToast() {
      if (!toast) return;
      toast.classList.remove('is-visible');
      setTimeout(function () {
        toast.setAttribute('hidden', '');
      }, 250);
    }

    function updateCartCount(count) {
      if (!cartCount) return;
      cartCount.textContent = count;
      if (count > 0) {
        cartCount.removeAttribute('hidden');
      } else {
        cartCount.setAttribute('hidden', '');
      }
    }

    // Scroll reveal animations
    if ('IntersectionObserver' in window) {
      var revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });

      function observeReveals() {
        document.querySelectorAll('.reveal:not(.is-visible)').forEach(function (el) {
          revealObserver.observe(el);
        });
      }

      observeReveals();

      // Re-scan when sections are dynamically inserted (theme editor)
      if (window.MutationObserver) {
        new MutationObserver(observeReveals).observe(document.body, { childList: true, subtree: true });
      }
    } else {
      document.querySelectorAll('.reveal').forEach(function (el) {
        el.classList.add('is-visible');
      });
    }

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches('form[action$="/cart/add"]')) return;
      e.preventDefault();

      var submitBtn = form.querySelector('[type="submit"]');
      var originalText = submitBtn ? submitBtn.textContent : null;
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Adding…';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function () {
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
        })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          showToast('Added to your bag');
        })
        .catch(function () {
          showToast('Something went wrong — please try again');
        })
        .finally(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            if (originalText) submitBtn.textContent = originalText;
          }
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kitch-merch"] && !Shopify.designMode) return;
  try {
    
  var swipeTouchStartX = 0;
  var swipeTouchStartY = 0;

  document.addEventListener('touchstart', function (e) {
    var wrap = e.target.closest('.product-card__image-wrap');
    if (!wrap) return;
    swipeTouchStartX = e.touches[0].clientX;
    swipeTouchStartY = e.touches[0].clientY;
  }, { passive: true });

  document.addEventListener('touchend', function (e) {
    var wrap = e.target.closest('.product-card__image-wrap');
    if (!wrap) return;
    if (!wrap.querySelector('.product-card__image--back')) return;

    var deltaX = e.changedTouches[0].clientX - swipeTouchStartX;
    var deltaY = e.changedTouches[0].clientY - swipeTouchStartY;

    if (Math.abs(deltaX) < 40 || Math.abs(deltaX) < Math.abs(deltaY)) return;

    var card = wrap.closest('.product-card');
    if (!card) return;

    var isFlipped = wrap.classList.contains('is-flipped');
    var newIndex = deltaX < 0 ? 1 : 0;

    if ((newIndex === 1 && isFlipped) || (newIndex === 0 && !isFlipped)) return;

    wrap.classList.toggle('is-flipped', newIndex === 1);
    card.querySelectorAll('.product-card__dot').forEach(function (d) {
      d.classList.toggle('is-active', parseInt(d.dataset.dotIndex) === newIndex);
    });
  }, { passive: true });

  document.addEventListener('click', function (e) {
    var dot = e.target.closest('.product-card__dot');
    if (dot) {
      e.preventDefault();
      var card = dot.closest('.product-card');
      if (!card) return;
      var index = parseInt(dot.dataset.dotIndex);
      var wrap = card.querySelector('.product-card__image-wrap');
      if (wrap) wrap.classList.toggle('is-flipped', index === 1);
      card.querySelectorAll('.product-card__dot').forEach(function (d) {
        d.classList.toggle('is-active', parseInt(d.dataset.dotIndex) === index);
      });
      return;
    }

    var swatch = e.target.closest('.product-card__swatch');
    if (!swatch) return;
    var newFront = swatch.dataset.image;
    if (!newFront) return;
    var card = swatch.closest('.product-card');
    if (!card) return;

    var frontImg = card.querySelector('.product-card__image--front');
    var backImg = card.querySelector('.product-card__image--back');

    if (frontImg) { frontImg.src = newFront; frontImg.srcset = ''; }

    if (backImg) {
      var newBack = swatch.dataset.backImage;
      if (newBack) {
        backImg.src = newBack;
        backImg.srcset = '';
        backImg.style.display = '';
      } else {
        backImg.style.display = 'none';
      }
    }

    var wrap = card.querySelector('.product-card__image-wrap');
    if (wrap) wrap.classList.remove('is-flipped');

    card.querySelectorAll('.product-card__dot').forEach(function (d) {
      d.classList.toggle('is-active', parseInt(d.dataset.dotIndex) === 0);
    });

    card.querySelectorAll('.product-card__swatch').forEach(function (s) {
      s.classList.remove('is-active');
    });
    swatch.classList.add('is-active');
  });

  } catch(e) { console.error(e); }
})();
})();
